import { CashRegisterIcon } from './CashRegisterIcon';

/**
 * author: TheManuz
 * id 6B63F864-415A-4679-9126-363E5254B175
 * name cash-register
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-register.svg
 * tags
 * - Shopping 
 * - Banking 
 */
export const TillIcon = CashRegisterIcon;
export default TillIcon